import * as elements from '../UiElements';

export const setButtonClick = (tgt) => {
  // remove selected class from all elements
  // create an array from the child elements
  const quanArr = Array.from(tgt.parentNode.children);
  // loop over the array and remove the 'selected' class
  quanArr.forEach((el) => el.classList.remove('shadow'));
  // add selected to target element
  tgt.classList.add('shadow');
};

export const updateIngQty = (arr, parent) => {
  arr.forEach((i) => {
    const templ = `
      <div class="ingredient-row white-cta ${
        i.type
      }" data-ingredient-name="${i.name}">
        <span class="ingredient-row-sub-flex" data-ingredient-name="${i.name}">
          <span class="ingredient-quantity" data-ingredient-name="${
            i.name
          }">${Math.round(i.qty)}g</span>
          <span class="ingredient-name" data-ingredient-name="${i.name}">${
      i.name
    }</span>
        </span>
        <span class="ingredient-percent inline-button" data-ingredient-name="${
          i.name
        }">${Math.round(i.BPct * 100)}%</span>
      </div>
      `;
    parent.insertAdjacentHTML('beforeend', templ);
  });
};

export const emptyParent = (parent) => {
  parent.innerHTML = '';
};

export const showIngModal = () => {
  elements.overlay.classList.remove('hidden');
  //window.location.hash = 'add';
};

export const hideIngModal = () => {
  //window.location.hash = '';
  clearModalValues();
  hideDeleteIngButton();
  elements.overlay.classList.add('hidden');
};

export const clearModalValues = () => {
  elements.newIngName.value = '';
  elements.newIngQty.value = '';
  elements.newIngBPct.value = '';
  // un-select the buttons
  const newArr = Array.from(elements.newIngTypeParent.children);
  newArr.forEach((el) => el.classList.remove('shadow'));
};

export const addIngredientsToModal = (name, qty, type) => {
  elements.newIngName.value = name;
  elements.newIngQty.value = qty;

  // find the selected type
  const newArr = Array.from(elements.newIngTypeParent.children);
  newArr.forEach((el) => {
    if (el.innerHTML.toLowerCase() === type) {
      el.classList.add('shadow');
    } else {
      el.classList.remove('shadow');
    }
  });
};

export const showDeleteIngButton = () => {
  elements.deleteIngButton.classList.remove('hidden');
};

export const hideDeleteIngButton = () => {
  elements.deleteIngButton.classList.add('hidden');
};

export const hideNewInput = () => {
  //hide all the input boxes
  const allInputBoxes = Array.from(document.querySelectorAll('.input-box'));
  allInputBoxes.forEach((e) => e.classList.add('hidden'));

  // clear the values from all input elements in the document
  const allInputs = Array.from(document.querySelectorAll('input'));
  allInputs.forEach((e) => (e.value = ''));

  // show all the plusses
  const allPlusEls = Array.from(document.querySelectorAll('.plus'));
  allPlusEls.forEach((e) => e.classList.remove('hidden', 'selected'));
};
